"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverTrigger: function() {
        return _TeachingPopoverTrigger.TeachingPopoverTrigger;
    },
    renderTeachingPopoverTrigger_unstable: function() {
        return _renderTeachingPopoverTrigger.renderTeachingPopoverTrigger_unstable;
    },
    useTeachingPopoverTrigger_unstable: function() {
        return _useTeachingPopoverTrigger.useTeachingPopoverTrigger_unstable;
    }
});
const _TeachingPopoverTrigger = require("./TeachingPopoverTrigger");
const _renderTeachingPopoverTrigger = require("./renderTeachingPopoverTrigger");
const _useTeachingPopoverTrigger = require("./useTeachingPopoverTrigger");
